import styled from "styled-components";
import { FLEX } from "styles/flex";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import * as mediaQuery from "components/MediaQuery";
import AccountId from "./AccountId";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  level: LEVEL_TYPE;
  accountNumber: string;
  accountName: string;
  direction?: "row" | "column";
}

const AccountInfoLabel = ({
  level,
  accountNumber,
  accountName,
  direction = "row",
  ...rest
}: Props) => (
  <AccountBox {...rest} direction={direction}>
    <AccountId accountId={accountNumber} level={level} />
    <span className="account-info-label-accountName">{accountName}</span>
  </AccountBox>
);

const AccountBox = styled.div<{
  direction: "row" | "column";
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}>`
  ${FLEX.FlexStartCenter};
  flex-direction: ${({ direction }) => direction};
  align-items: ${({ direction }) =>
    direction === "column" ? "flex-start" : "center"};
  flex-wrap: wrap;
  column-gap: 6px;
  row-gap: 2px;
  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  ${mediaQuery.isMobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export default AccountInfoLabel;
